import React from 'react'
import { Row, Col, ListGroup } from 'react-bootstrap';

import { getFileNameFromPath } from '../components/tools';

export const CardPreviewMedia = (experience) => {

    if (experience.video_360 || experience.video_flat)
        return (
            <div className="m-3">
                <Row>
                    <Col>
                        <h6 className="FormSubTitle">360 Video</h6>
                        {experience.video_360.length && experience.video_360.map((video_item, index) =>
                            <ListGroup.Item action key={video_item.id} className="ListItemStyled">
                                <span className="FormText">{video_item.name}</span>
                                {video_item.file && video_item.file !== null &&
                                    <a className="mx-2" target="_blank"
                                        rel="noopener noreferrer"
                                        href={`${process.env.REACT_APP_API}/static/video_360/${video_item.id}/${encodeURIComponent(getFileNameFromPath(video_item.file))}`}>
                                        <img src='/img/Edit.png' alt="" className="CardBlockHederImgSmall" /></a>}
                            </ListGroup.Item>
                        )}
                    </Col>

                    <Col>
                        <h6 className="FormSubTitle">Flat Video</h6>
                        {experience.video_flat.length && experience.video_flat.map((video_item, index) =>
                            <ListGroup.Item action key={video_item.id} className="ListItemStyled">
                                <span className="FormText">{video_item.name}</span>
                                {video_item.file && video_item.file !== null &&
                                    <a className="mx-2" target="_blank"
                                        rel="noopener noreferrer"
                                        href={`${process.env.REACT_APP_API}/static/video_flat/${video_item.id}/${encodeURIComponent(getFileNameFromPath(video_item.file))}`}>
                                        <img src='/img/Edit.png' alt="" className="CardBlockHederImgSmall" /></a>}
                            </ListGroup.Item>
                        )}
                    </Col>
                </Row>

            </div>
        )
    else
        return (<div></div>);
}
